<template>
    <div class="cert_container">
        <router-link class="card" to="/id_card">
            <img src="../assets/img/idcard.jpg" class="coverImg" alt="">
            <div class="cert_content">
                <h2>身份证翻译</h2>
                <div class="info">提供精美的身份证翻译服务</div>
                <router-link to="/id_card">了解详情 >></router-link>
            </div>
        </router-link>
<!--        <router-link class="card" to="/business_license">-->
<!--            <img src="../assets/img/business_license.jpg" class="coverImg" alt="">-->
<!--            <div class="cert_content">-->
<!--                <h2>营业执照翻译</h2>-->
<!--                <div class="info">提供精美的营业执照翻译服务</div>-->
<!--                <router-link to="/business_license">了解详情 >></router-link>-->
<!--            </div>-->
<!--        </router-link>-->
    </div>
</template>

<script>
    export default {
        name: 'index',
    }
</script>

<style>
    .cert_container{
        width: 1000px;
        height: auto;
        margin: 60px auto;
        display: flex;
        justify-content: space-between;
    }
    .card{
        width: 480px;
        height: 400px;
        background-color: #fff;
        border-radius: 3px;
        display: inline-block;
        overflow: hidden;
    }
    .coverImg{
        width: 100%;
        height: 260px;
        border-radius: 3px;
        margin: 0 auto;
    }
    .cert_content{
        padding: 20px 15px;
    }
    .cert_content h2{
        font-size: 23px;
        color: #1a1a1a;
    }
    .cert_content .info{
        color: #8590A6;
        font-size: 14px;
        margin: 10px 0 25px;
    }
    .cert_content a{
        color: #d82a22;
        text-decoration: underline;
    }
</style>
